import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

// ── Query key factories ──

export const itemKeys = {
  all: ["items"] as const,
  list: (filters: { search?: string; status?: string }) => ["items", "list", filters] as const,
  detail: (id: string) => ["items", "detail", id] as const,
};

export const userKeys = {
  all: ["users"] as const,
  list: (filters?: { search?: string }) => ["users", "list", filters] as const,
} as const;

export const devKeys = {
  seedAccounts: ["dev", "seed-accounts"] as const,
} as const;

export const emailKeys = {
  all: ["email"] as const,
  outbox: () => ["email", "outbox"] as const,
  templates: () => ["email", "templates"] as const,
  template: (key: string) => ["email", "templates", key] as const,
} as const;

export const courseKeys = {
  all: ["courses"] as const,
  list: () => ["courses", "list"] as const,
  progress: (slug: string) => ["courses", "progress", slug] as const,
} as const;

export const adminCourseKeys = {
  all: ["admin", "courses"] as const,
  list: () => ["admin", "courses", "list"] as const,
} as const;

export const adminTrainingKeys = {
  all: ["admin", "training"] as const,
  list: (filters?: { search?: string }) => ["admin", "training", "list", filters] as const,
} as const;
